import { useEffect } from 'react';
import { Box, Title, Icon, chooseColor } from 'vopay';
import styles from './Messages.module.scss';
import { useLayout } from '@/providers/Layout.provider';
import { useToken } from '@/providers/Token.provider';
import useFetchPaylinkSingleUseToken from '@/hooks/useApi/useFetchPaylinkSingleUseToken';
import useStorage from '@/hooks/useStorage';
import { useTranslation } from 'react-i18next';

export default function Error() {
  const { setLayoutInfo } = useLayout();
  const { token } = useToken();
  const storage = useStorage();
  const { Token } = storage.paylinkToken.getPaylinkToken();
  const [paylink, fetchSingleUseTokenInfo] = useFetchPaylinkSingleUseToken({});
  const { t } = useTranslation('translations', { keyPrefix: 'Error' });
  useEffect(() => {
    setLayoutInfo(
      chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      false,
      true,
    );
  }, []);

  useEffect(() => {
    fetchSingleUseTokenInfo({
      Token,
      ApplicationType: 'paylink',
    });
  }, [Token]);

  return (
    <div className={styles.errorMsgContainer}>
      <Box flx="col" height="auto" ai="center">
        <div className={styles.iconContainer}>
          <Icon icon="error3" width="100%" height="100%" color="none" />
        </div>
        <Title title={t('unsuccessfulTitle', { defaultValue: 'Transaction Unsuccessful' })} size="lg" bold center />
        {paylink.Success && (
          <div className={styles.text}>
            {t('unsuccessfulMessage', {
              senderName: paylink?.ExtraInfo.PayLinkDetails.SenderName,
              defaultValue:
                'We encountered an issue processing your payment due to an unexpected error. Please try again, or reach out to {{senderName}} Support for assistance.',
            })}
          </div>
        )}
      </Box>
    </div>
  );
}
